import { Card, Group, Stack, Text } from "@mantine/core";
import { dateTimeToString } from "../../../../../utils/dateTimeUtils";
import { CALENDAR_TYPES } from "../../../../constants/calendarConstants";
import { COLORS } from "../../../../constants/colorConstants";
import { useCalendarContext } from "../../../../contexts/CalendarContext";
import { useLocalAuthorityContext } from "../../../../contexts/LocalAuthorityContext";
import { StaffLink } from "../../../../shared/components/ui/StaffLink";
import { getLabelById } from "../../../../utils/objectUtils";

export default function CalendarViewDetailsCard() {
  return (
    <Card shadow="xs" p="md" radius="lg" mb="md" miw={520} withBorder bg={COLORS.WHEAT} c={COLORS.DARK_BROWN}>
      <Stack>
        <NameDisplay />
        <TypeDisplay />
        <LocalAuthorityDisplay />
        <StartDateDisplay />
        <EndDateDisplay />
        <ActiveDisplay />
        <CreatedAtDisplay />
        <CreatedByDisplay />
        <UpdatedAtDisplay />
        <UpdatedByDisplay />
      </Stack>
    </Card>
  );
}

function NameDisplay() {
  const { singleFetch } = useCalendarContext();

  return (
    <Group justify="space-between">
      <Text fw={700}>Name</Text>
      <Text>{singleFetch?.data?.name}</Text>
    </Group>
  );
}

function TypeDisplay() {
  const { singleFetch } = useCalendarContext();
  const label = getLabelById(CALENDAR_TYPES, singleFetch?.data?.type);

  return (
    <Group justify="space-between">
      <Text fw={700}>Type</Text>
      <Text>{label}</Text>
    </Group>
  );
}

function LocalAuthorityDisplay() {
  const { singleFetch } = useCalendarContext();
  const { dropdownFetch } = useLocalAuthorityContext();

  const localAuthorities = dropdownFetch?.data ?? [];
  const localAuthority = localAuthorities.find((x) => x.id === singleFetch?.data?.localAuthorityId) ?? {};

  return (
    <Group justify="space-between">
      <Text fw={700}>Local Authority</Text>
      <Text>{localAuthority.name}</Text>
    </Group>
  );
}

function StartDateDisplay() {
  const { singleFetch } = useCalendarContext();
  const label = dateTimeToString(singleFetch?.data?.startDate, "dd/MM/yyyy");

  return (
    <Group justify="space-between">
      <Text fw={700}>Start Date</Text>
      <Text>{label}</Text>
    </Group>
  );
}

function EndDateDisplay() {
  const { singleFetch } = useCalendarContext();
  const label = dateTimeToString(singleFetch?.data?.endDate, "dd/MM/yyyy");

  return (
    <Group justify="space-between">
      <Text fw={700}>End Date</Text>
      <Text>{label}</Text>
    </Group>
  );
}

function ActiveDisplay() {
  const { singleFetch } = useCalendarContext();

  return (
    <Group justify="space-between">
      <Text fw={700}>Active</Text>
      <Text>{singleFetch?.data?.isActive ? "Yes" : "No"}</Text>
    </Group>
  );
}

function CreatedAtDisplay() {
  const { singleFetch } = useCalendarContext();
  const label = dateTimeToString(singleFetch?.data?.metadata?.createdAt);

  return (
    <Group justify="space-between">
      <Text fw={700}>Created At</Text>
      <Text>{label}</Text>
    </Group>
  );
}

function CreatedByDisplay() {
  const { singleFetch } = useCalendarContext();

  return (
    <Group justify="space-between">
      <Text fw={700}>Created By</Text>
      <StaffLink staffId={singleFetch?.data?.metadata?.createdBy} style={{ rightLabelColor: COLORS.DARK_BROWN }} />
    </Group>
  );
}

function UpdatedAtDisplay() {
  const { singleFetch } = useCalendarContext();
  const label = dateTimeToString(singleFetch?.data?.metadata?.updatedAt);

  return (
    <Group justify="space-between">
      <Text fw={700}>Last Update</Text>
      <Text>{label}</Text>
    </Group>
  );
}

function UpdatedByDisplay() {
  const { singleFetch } = useCalendarContext();

  return (
    <Group justify="space-between">
      <Text fw={700}>Updated By</Text>
      <StaffLink staffId={singleFetch?.data?.metadata?.updatedBy} style={{ rightLabelColor: COLORS.DARK_BROWN }} />
    </Group>
  );
}
